import { ColumnDef } from "@tanstack/react-table";
import { MentorshipFeedback } from "@/lib/api/mentorships.ts";
import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header.tsx";
import { formatDate } from "@/lib/utils.ts";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const columns: ColumnDef<
  MentorshipFeedback["teenWellBeing"]["history"][number]
>[] = [
  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Date" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex items-center justify-center">
          {row.original.created_at
            ? formatDate(row.original.created_at) || "-"
            : "-"}
        </div>
      );
    },
  },
  {
    accessorKey: "phq_response",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="PHQ" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      const isPHQ2 = !row.original.phq8Response && row.original.phq2Response;
      return (
        <div className="flex items-center justify-center gap-1">
          {row.original.phq8Response || row.original.phq2Response || "-"}
          {isPHQ2 && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Info className="h-3 w-3 text-zinc-500" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>PHQ-2 Response</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "gad_response",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="GAD" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      const isGAD2 = !row.original.gad8Response && row.original.gad2Response;
      return (
        <div className="flex items-center justify-center gap-1">
          {row.original.gad8Response || row.original.gad2Response || "-"}
          {isGAD2 && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Info className="h-3 w-3 text-zinc-500" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>GAD-2 Response</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "risk_response",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Risk" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      const isOldRisk =
        !row.original.riskResponseNew && row.original.riskResponse;
      return (
        <div className="flex items-center justify-center gap-1">
          {row.original.riskResponseNew || row.original.riskResponse || "-"}
          {isOldRisk && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Info className="h-3 w-3 text-zinc-500" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Legacy Risk Response</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      );
    },
  },
];
